import type { EntryStatus } from '../../models';

// Configuración de colores para estados de entry
export const ENTRY_STATUS_CONFIG: Record<
  EntryStatus,
  { bg: string; text: string; label: string }
> = {
  PENDIENTE: {
    bg: 'bg-card-border light:bg-badge-bg-status-1',
    text: 'text-badge-status-1',
    label: 'Pendiente',
  },
  EN_RECEPCION: {
    bg: 'bg-card-border light:bg-bg-warning',
    text: 'text-warning',
    label: 'En recepción',
  },
  EN_RECEPCION_PARCIAL: {
    bg: 'bg-card-border light:bg-orange-100',
    text: 'text-orange-600',
    label: 'En recepción parcial',
  },
  FINALIZADA: {
    bg: 'bg-bg-success',
    text: 'text-success',
    label: 'Finalizada',
  },
  CANCELADA: {
    bg: 'bg-bg-error',
    text: 'text-error',
    label: 'Cancelada',
  },
};

// Opciones de estado para filtros (MultiSelect)
export const ENTRY_STATUS_OPTIONS = [
  { value: 'PENDIENTE', label: 'Pendiente' },
  { value: 'EN_RECEPCION', label: 'En recepción' },
  { value: 'EN_RECEPCION_PARCIAL', label: 'En recepción parcial' },
  { value: 'FINALIZADA', label: 'Finalizada' },
  { value: 'CANCELADA', label: 'Cancelada' },
];

// Configuración de botones del toolbar (tabs de estado)
export interface ToolbarButton {
  key: string;
  link: string;
  status?: EntryStatus;
}

export const ENTRY_TOOLBAR_BUTTONS: ToolbarButton[] = [
  { key: 'all', link: '#' },
  { key: 'pending', link: '#', status: 'PENDIENTE' },
  { key: 'in_reception', link: '#', status: 'EN_RECEPCION' },
  { key: 'partial_reception', link: '#', status: 'EN_RECEPCION_PARCIAL' },
  { key: 'finished', link: '#', status: 'FINALIZADA' },
  { key: 'cancelled', link: '#', status: 'CANCELADA' },
];

// Mapeo de status code a label
export const getEntryStatusConfig = (status: EntryStatus) => {
  return ENTRY_STATUS_CONFIG[status] || ENTRY_STATUS_CONFIG.PENDIENTE;
};

